import { useState, useEffect } from 'react';

export const useDuplicatePhotoSelection = (photosWithDuplicates) => {
  const [selectedPhotos, setSelectedPhotos] = useState(new Set());

  useEffect(() => {
    const allDuplicateIds = photosWithDuplicates.flatMap(
      (p) => p.duplicateImageIds,
    );
    setSelectedPhotos(new Set(allDuplicateIds));
  }, [photosWithDuplicates]);

  const handlePhotoSelection = (imageId) => {
    setSelectedPhotos((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(imageId)) {
        newSelected.delete(imageId);
      } else {
        newSelected.add(imageId);
      }
      return newSelected;
    });
  };

  const handleBulkAdd = (imageIds) => {
    setSelectedPhotos((prevSelected) => {
      const newSelected = new Set(prevSelected);
      imageIds.forEach((id) => newSelected.add(id));
      return newSelected;
    });
  };

  const handleBulkRemove = (imageIds) => {
    setSelectedPhotos((prevSelected) => {
      const newSelected = new Set(prevSelected);
      imageIds.forEach((id) => newSelected.delete(id));
      return newSelected;
    });
  };

  const allDuplicateIds = photosWithDuplicates.flatMap(
    (p) => p.duplicateImageIds,
  );
  const allDuplicatesCount = new Set(allDuplicateIds).size;
  const allSelected = selectedPhotos.size === allDuplicatesCount;

  const handleSelectAllDuplicates = () => {
    setSelectedPhotos(new Set(allDuplicateIds));
  };

  return {
    selectedPhotos,
    allSelected,
    handlePhotoSelection,
    handleBulkAdd,
    handleBulkRemove,
    handleSelectAllDuplicates,
  };
};
